import type { Dispatch } from 'react'

export enum COHORT_TYPE {
  COHORT_1 = 'cohort1',
  COHORT_2 = 'cohort2',
}

interface ComputedFiltersDate {
  range: {
    end: string
    start: string
  }
}

interface ComputedFilters {
  key: string
  value: string[]
}

export type TFilterKey =
  | 'abtestKey'
  | 'breakdown'
  | 'dai'
  | 'deviceCategory'
  | 'deviceType'
  | 'endDate'
  | 'installationAppVersion'
  | 'installationCountry'
  | 'kpi'
  | 'navigationGraphId'
  | 'placementKey'
  | 'uaSource'
  | 'userType'
  | 'startDate'

export type TFilters = Partial<Record<TFilterKey, string[]>>

export interface IStateReducer {
  computedFilters: ComputedFilters[]
  computedFiltersDate: ComputedFiltersDate
  displayedFilters: Record<
    | 'datePicker'
    | 'dropdownDai'
    | 'dropdownInstallationAppVersion'
    | 'dropdownInstallationCountry'
    | 'dropdownDeviceCategory'
    | 'dropdownUaSource'
    | 'dropdownUserType'
    | 'dropdownBreakdown',
    boolean
  >
  filters: TFilters
  isFiltersCollapsed?: boolean
}

export interface ICompareCohortsState {
  [key: string]: IStateReducer
}

export interface IActionReducer {
  cohort: COHORT_TYPE
  payload?: any
  type: 'filters' | 'isFiltersCollapsed' | 'resetFilters'
}

export interface ICompareCohortsContext {
  dispatch: Dispatch<IActionReducer>
  state: ICompareCohortsState
}
